module.exports = __webpack_public_path__ + "img/Mascherina_SX.ffa63014.png";